import { commitFilesDiffer } from "./commitFilesDiffer";
import { isUntouchedReadmeStub } from "./readmeStub";

type FileWithBlob = {
  path: string;
  blobHash: string;
  blob: { content: string } | undefined;
};

// A brand-new workflow's only committed file is the stub README; it isn't a
// real change worth pushing live, so strip it from both sides before comparing.
export function hasPushableChanges(
  forkFiles: readonly FileWithBlob[],
  headFiles: readonly FileWithBlob[]
): boolean {
  return commitFilesDiffer(
    forkFiles.filter((f) => !isUntouchedReadmeStub(f)),
    headFiles.filter((f) => !isUntouchedReadmeStub(f))
  );
}
